import React, { Component } from 'react';

class Skills extends Component {

  constructor()
  {
    super();

    this.state = {
      'programming': ['Java', 'Python', 'JavaScript', 'C', 'C++', 'PHP', 'MATLAB', 'SQL'],
      'web': ['HTML5', 'CSS3', 'ReactJS', 'Redux', 'VueJS', 'Vuex', 'Semantic UI', 'Bulma', 'Handlebars', 'Datatables'],
      'bigdata': ['Hadoop', 'Apache Spark', 'Docker', 'MapReduce', 'Tableau', 'NLTK', 'Jupyter'],
      'other': ['Flask', 'Tomcat', 'NodeJS', 'Derby', 'JDBC', 'SOAP', 'REST', 'TCP/IP', 'DialogFlow', 'PyTorch']
    }

    this.listSkills = this.listSkills.bind(this)
  }

  listSkills(skills){
    const skillItems = skills.map((skill, i)=>{
      return(
        <span key={i} className="tag is-medium is-light">{skill}</span>
      )
    })
    return skillItems
  }

  render() {
    return (
      <div id="skills">

        <div className="column has-text-centered has-text-weight-bold">
          <p className="title is-5 is-blue has-text-bold is-heading padding-two-top">SKILLS</p>
          <div className="columns is-centered">
            <div className="column is-6 has-text-centered">
              <p className="subtitle is-3 is-black has-text-bold">
                What have I learned so far?
              </p>
              <p className="has-text-weight-light is-size-5">
                Having spent over 5 years in this field and countless hours in front of a computer screen, 
                I've learned a couple things and continue to learn more!
              </p>
            </div>
          </div>
        </div>

        <div className="column">        
          <section className="hero">
            <div className="hero-body">

              <div className="columns is-desktop">
                <div className="column">
                  <div className="content has-text-centered">
                    <aside className="menu">
                      <p className="menu-label is-size-7-mobile is-size-6">
                        PROGRAMMING
                      </p>
                      <div className="tags">
                        {this.listSkills(this.state.programming)}
                      </div>
                    </aside>
                  </div>
                </div>
                <div className="column">
                  <div className="content has-text-centered">
                    <aside className="menu">
                      <p className="menu-label is-size-7-mobile is-size-6">
                        WEB TECHNOLOGIES
                      </p>
                      <div className="tags">
                        {this.listSkills(this.state.web)}
                      </div>
                    </aside>
                  </div>
                </div>
                <div className="column">
                  <div className="content has-text-centered">
                    <aside className="menu">
                      <p className="menu-label is-size-7-mobile is-size-6">
                        BIG DATA
                      </p>
                      <div className="tags">
                        {this.listSkills(this.state.bigdata)}
                      </div>
                    </aside>
                  </div>
                </div>
                <div className="column">
                  <div className="content has-text-centered">
                    <aside className="menu">
                      <p className="menu-label is-size-7-mobile is-size-6">
                        OTHER
                      </p>
                      <div className="tags">
                        {this.listSkills(this.state.other)}
                      </div>
                    </aside>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default Skills;